import axios from "axios";
import { firebaseAuth } from '../../firebase';
import { 
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  sendPasswordResetEmail
} from 'firebase/auth';

export const ME_URL = process.env.REACT_APP_FLIT_API_URL + "/users/me";

// ✅ Firebase Email Login
export function login(email, password) {
  return signInWithEmailAndPassword(firebaseAuth, email, password);
}

// ✅ Firebase Social Login
export async function loginWithGoogle() {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(firebaseAuth, provider);
  const token = await result.user.getIdToken();
  
  // Sync with backend
  await axios.post(
    process.env.REACT_APP_FLIT_API_URL + "/Users/social-login",
    {
      firstName: result.user.displayName?.split(' ')[0],
      lastName: result.user.displayName?.split(' ').slice(1).join(' '),
      provider: 'GOOGLE'
    },
    { headers: { 'Authorization': `Bearer ${token}` } }
  );
  
  return result;
}

export async function loginWithFacebook() {
  const provider = new FacebookAuthProvider();
  const result = await signInWithPopup(firebaseAuth, provider);
  const token = await result.user.getIdToken();
  
  await axios.post(
    process.env.REACT_APP_FLIT_API_URL + "/Users/social-login",
    {
      firstName: result.user.displayName?.split(' ')[0],
      lastName: result.user.displayName?.split(' ').slice(1).join(' '),
      provider: 'FACEBOOK'
    },
    { headers: { 'Authorization': `Bearer ${token}` } }
  );
  
  return result;
}

// ✅ Get current Firebase token
export async function getFirebaseToken() {
  const user = firebaseAuth.currentUser;
  if (user) {
    return await user.getIdToken(true); // Force refresh
  }
  return localStorage.getItem('jwt'); // Fallback to WeChat JWT
}

export function getRegistrationChannel(email) {
  return axios.get(process.env.REACT_APP_FLIT_API_URL + "/Users/Social?email=" + email); 
}

export function register(email, firstName, lastName, password) {
  return axios.post(process.env.REACT_APP_FLIT_API_URL + "/Users/register", 
    { email, firstName, lastName, password });  
}

export function requestPassword(email) {
  return sendPasswordResetEmail(firebaseAuth, email);
}

export function getUserByToken() {
  return axios.get(ME_URL);
}